import LOBBY from "../actions/lobby/types";

const initialState = {
    activeRoomId: null,
    activePage: 'Cash',
    promos: {},
    rakeRace: {
        isActive: false,
        progress: {},
        finished: {},
        information: {},
    },
    activeModalName: '',
    server: {
        msg: '',
        details: {},
    },
    loader: {
        isActive: true,
        loaderMsg: ''
    },
    audioEnabled: false,
    maintenance: []
};
const reducer = (state = initialState, action) => {

        switch (action?.type) {

            case LOBBY.SET_ACTIVE_PAGE:
                return {
                    ...state,
                    activePage: action.payload.activePage,
                    activeRoomId: null
                }

            case LOBBY.SET_PROMO_DATA:
                return {
                    ...state,
                    promos: action.payload.promos,
                }


            case LOBBY.DELETE_SINGLE_PROMO:
                const promos = [...state.promos].filter(promo => promo.id !== action.payload.id);
                return {
                    ...state,
                    promos,
                }


            case LOBBY.ADD_SINGLE_PROMO:
                return {
                    ...state,
                    promos: [
                        ...state.promos,
                        action.payload.promo
                    ],
                }

            case LOBBY.SELECT_ACTIVE_ROOM_TAB:
                return {
                    ...state,
                    activeRoomId: action.payload.roomId,
                }

            case  LOBBY.OPEN_MODAL:
                return {
                    ...state,
                    activeModalName: action.payload.name
                }

            case  LOBBY.CLOSE_MODAL:
                return {
                    ...state,
                    activeModalName: ''
                }

            case  LOBBY.SET_SERVER_MESSAGE:
                return {
                    ...state,
                    activeModalName: 'ServerInfoModal',
                    server: action.payload,
                }

            case  LOBBY.SET_SERVER_BONUS_MESSAGE:
                return {
                    ...state,
                    activeModalName: 'ServerBonusInfoModal',
                    server: action.payload,
                }


            case  LOBBY.SET_LOADER:
                return {
                    ...state,
                    loader: {
                        isActive: true,
                        msg: action.payload.err
                    }
                };

            case  LOBBY.UNSET_LOADER:
                return {
                    ...state,
                    loader: {
                        isActive: false,
                        msg: ''
                    }
                };
            case LOBBY.SET_RAKE_RACE_DATA:
                let modalName = state.activeModalName
                if (state.activeModalName === 'RakeRace' && !action.payload?.isActive) {
                    modalName = ''
                }
                return {
                    ...state,
                    rakeRace: action.payload,
                    activeModalName: modalName
                }
            case LOBBY.UPDATE_RAKE_RACE_PROGRESS_LEADER_BOARD:
                return {
                    ...state,
                    rakeRace: {
                        ...state.rakeRace,
                        progress: {
                            ...state.rakeRace.progress,
                            leaderBoard: action.payload.leaderBoard
                        },
                    },
                }

            case LOBBY.TOGGLE_AUDIO:
                return {
                    ...state,
                    audioEnabled: !state.audioEnabled
                }

            case LOBBY.SET_MAINTENANCE:
                return {
                    ...state,
                    maintenance: action.payload.maintenance
                }

            default:
                return state;
        }
    }
;
export default reducer;
